const LinkLists = [
  {
    heading: "Product",
    pages: [
      { title: "How it works", link: "how-it-works" },
      { title: "Features   ", link: "features" },
      { title: "Mobile App", link: "mobileapp" },
      { title: "Use case collection", link: "use-cases" },
      { title: "Pricing   ", link: "pricing" },
      { title: "Customer Reviews", link: "" },
      { title: "Start Free", link: "signup" },
    ],
  },
  {
    heading: "Resources",
    pages: [
      { title: "Time Tracking", link: "" },
      { title: "About ", link: "about" },
      { title: "Terms of Use", link: "" },
      { title: "Sitemap", link: "" },
      { title: "Free Timesheet templates   ", link: "" },
      { title: "Time Management Apps", link: "" },
      { title: "Best Time Tracking Apps of 2022", link: "" },
      { title: "Free Time Card Calculator", link: "" },
    ],
  },
  {
    heading: "Use cases",
    pages: [
      { title: "Project billing", link: "" },
      { title: " Time reports and Project analytics ", link: "" },
      { title: "Attendance and Absence tracking", link: "" },
      { title: "Expense tracking", link: "" },
      { title: " Calculating project profitability ", link: "" },
      { title: "Timesheet time tracking", link: "" },
    ],
  },
  {
    heading: "Integrations",
    pages: [
      { title: "QuickBooks", link: "" },
      { title: " Zapier", link: "" },
    ],
  },
  {
    heading: "Social",
    pages: [
      { title: "Facebook", link: "" },
      { title: " Twitter", link: "" },
    ],
  },
];

export { LinkLists };
